import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import {
  FontColor,
  FontType,
  FontWeight,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';

export enum TagStatusColor {
  DEFAULT = 'default',
  BLUE = 'blue',
  GREEN = 'green',
  ORANGE = 'orange',
}

@Component({
  selector: 'fl-tag-status',
  template: `
    <fl-text
      [color]="FontColor.INHERIT"
      [fontType]="FontType.SPAN"
      [size]="TextSize.XSMALL"
      [textTransform]="TextTransform.UPPERCASE"
      [weight]="FontWeight.BOLD"
    >
      <ng-content></ng-content>
    </fl-text>
  `,
  styleUrls: ['./tag-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagStatusComponent {
  FontColor = FontColor;
  TextSize = TextSize;
  FontType = FontType;
  FontWeight = FontWeight;
  TextTransform = TextTransform;

  @HostBinding('attr.data-color')
  @Input()
  color: TagStatusColor = TagStatusColor.DEFAULT;
}
